import type {
  FormConditionalValidation,
  FormField,
  FormInitialValues,
  FormValidations,
} from '@/forms/typings';
import type { DateRangeFormField } from '@/forms/typings';
import { generateValidations } from '@/forms/utils/generateValidations';

import type { FormFieldModuleContext } from '../registry/field-module.types';

export function buildDateRangeInitialState(
  field: FormField,
  values: FormInitialValues,
  validations: FormValidations,
  conditions: FormConditionalValidation[] | undefined,
  ctx: FormFieldModuleContext,
): { initialValues: FormInitialValues; validationFields: FormValidations } {
  let initialValues: FormInitialValues = { ...values };
  let validationFields: FormValidations = { ...validations };

  const f = field as DateRangeFormField;

  if (f.notApplicableField) {
    initialValues[f.notApplicableField.fieldId] = f.notApplicableField.value;
  }

  for (const dateField of f.fields) {
    initialValues[dateField.fieldId] = dateField.value;

    const schema = generateValidations(dateField, conditions);

    if (!schema) continue;

    validationFields[dateField.fieldId] = schema;
  }

  if (f.naDetails && f.notApplicableField) {
    const combinedConditions: FormConditionalValidation[] = [
      { type: 'not-applicable', relatedFieldId: f.notApplicableField.fieldId },
      ...(conditions ?? []),
    ];

    const naValuesAndValidations = ctx.recurse(
      f.naDetails,
      initialValues,
      validationFields,
      combinedConditions,
    );

    initialValues = {
      ...initialValues,
      ...naValuesAndValidations.initialValues,
    };

    validationFields = {
      ...validationFields,
      ...naValuesAndValidations.validationFields,
    };
  }

  return { initialValues, validationFields };
}
